import type { HtmlAttributes } from '@studio/design-system/props';
import type { T_Maybe } from '@tryiris-ai/js-types';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';

import { getCurrentVendor } from '@studio/design-system/themes/vendor.js';
import type { Vendor } from '@studio/design-system/themes/vendor.js';

const logoMap: Record<Vendor, string> = {
  iris: '/assets/logo.png',
  ptzoptics: '/assets/ptzoptics/hive_badge_2.png'
};

const logoUrl = logoMap[getCurrentVendor()];

/** `<Logo>` component. */
export const Logo = ({
  className,
  name,
  photo,
  size,
  ...props
}: HtmlAttributes & { name: string; photo: T_Maybe<string>; size?: 'lg' | 'sm' }): ReactElement => {
  const hasPhoto = photo && photo.length !== 0 && photo.startsWith('http');

  const classNameModded = twMerge('inline-block aspect-square rounded-full', className);

  const px = size === 'lg' ? 80 : 24;

  if (hasPhoto) {
    return (
      <img alt={name} className={classNameModded} height={px} src={photo} width={px} {...props} />
    );
  }

  return (
    <img
      alt='Iris Studio'
      className={classNameModded}
      height={px}
      src={logoUrl}
      width={px}
      {...props}
    />
  );
};
